export class DTOCheckCatalogo {    
    IdEmpresa: number; 
    RedProdutoKey: string;   
    Referencia: string;
    Descricao: string;
    Cor: string;     
    Tamanho: string; 
    Acao: string;
    
    deserialize(input: Object): DTOCheckCatalogo {
        Object.assign(this, input);

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/dto/dtoCheckCatalogo.ts